export const JimglyphJson = {
	tag: 'svg',
	attr: { viewBox: '0 0 970.3091 951' },
	child: [
		{
			tag: 'g',
			attr: {},
			child: [
				{
					tag: 'g',
					attr: {},
					child: [
						{
							tag: 'path',
							attr: {
								d:
									'M278.3225,423.9355h50.16c-1.3492,14.4758,3.6931,190.4511-3.7931,198.6594-9.4737,31.542-51.7843,39.5856-78.0468,28.38V609.3955c12.6136,4.27,32.709,3.1812,31.6789-14.8515Zm-4.29-50.16c.064-38.8155,58.7283-38.6145,58.74.0011C332.36,412.392,274.6147,412.4414,274.0325,373.7754Z',
								transform: 'translate(-14.8452 -24.5)',
							},
							child: [],
						},
						{
							tag: 'path',
							attr: {
								d:
									'M384.1711,373.7754c.5855-38.6741,58.336-38.603,58.74.0012C442.4979,412.39,384.7543,412.4432,384.1711,373.7754Zm4.29,214.17v-164.01h50.16v164.01Z',
								transform: 'translate(-14.8452 -24.5)',
							},
							child: [],
						},
						{
							tag: 'path',
							attr: {
								d:
									'M498.2673,587.9453v-164.01h47.8506v18.81c20.1751-31.7528,78.7364-32.4582,95.7,1.98,16.1064-25.2043,46.1078-30.4016,73.4242-22.2749,15.3592,4.86,26.5134,15.3225,33,30.5249,9.8212,17.7781,3.3549,113.9946,5.1153,134.97h-48.51v-95.04c-.127-15.7518-8.5991-28.169-26.07-27.72-16.9475-.6258-27.32,12.8608-27.3887,28.05v94.71H601.8875v-95.04c-.1579-15.9439-8.6429-28.1788-26.3994-27.72-16.845-.57-27.0464,13.1172-27.0606,28.38v94.38Z',
								transform: 'translate(-14.8452 -24.5)',
							},
							child: [],
						},
					],
				},
				{
					tag: 'path',
					attr: {
						d:
							'M947.6543,975.5H52.3452a37.5423,37.5423,0,0,1-37.5-37.5V62a37.5423,37.5423,0,0,1,37.5-37.5H947.6543a37.5423,37.5423,0,0,1,37.5,37.5V938A37.5423,37.5423,0,0,1,947.6543,975.5Zm-881.8091-51H934.1543V75.5H65.8452Z',
						transform: 'translate(-14.8452 -24.5)',
					},
					child: [],
				},
			],
		},
	],
}
